import { render, staticRenderFns } from "./resetPasswordSmdUser.vue?vue&type=template&id=20bcb7a8&"
import script from "./resetPasswordSmdUser.vue?vue&type=script&lang=js&"
export * from "./resetPasswordSmdUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports